var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("el-card", { staticClass: "mb5" }, [
        _c(
          "div",
          { staticClass: "searchBox" },
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                attrs: { inline: false, "label-position": "top" },
                model: {
                  value: _vm.queryForm,
                  callback: function ($$v) {
                    _vm.queryForm = $$v
                  },
                  expression: "queryForm",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "searchTimeType" } },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "selectClass",
                                    style: _vm.IsWidthTime,
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseChoose"
                                      ),
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.queryForm.params.timeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "timeType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.timeType",
                                    },
                                  },
                                  _vm._l(_vm.timeTypeList, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "default-time": ["00:00:00", "23:59:59"],
                                "end-placeholder": _vm.$t(
                                  "operationCenter.endDate"
                                ),
                                format:
                                  _vm.$i18n.locale === "zh"
                                    ? _vm.zhDate
                                    : _vm.ptDate,
                                "start-placeholder": _vm.$t(
                                  "operationCenter.startDate"
                                ),
                                "range-separator": "~",
                                size: "small",
                                type: "datetimerange",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.timeValue,
                                callback: function ($$v) {
                                  _vm.timeValue = $$v
                                },
                                expression: "timeValue",
                              },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("home.position") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("GlobalSetObj.all"),
                                  clearable: "",
                                  filterable: "",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.queryForm.params.position,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "position",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.position",
                                },
                              },
                              _vm._l(_vm.positionList, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 5 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.transferCenter"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("GlobalSetObj.all"),
                                  clearable: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.queryForm.params.departmentIds,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "departmentIds",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.departmentIds",
                                },
                              },
                              _vm._l(_vm.TransferList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.registrar"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.Only10AreDisplayed"
                                  ),
                                  "remote-method": _vm.getRegistrationUserList,
                                  clearable: "",
                                  filterable: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.queryForm.params.registrationUser,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "registrationUser",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "queryForm.params.registrationUser",
                                },
                              },
                              _vm._l(_vm.registrationUserList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.realName,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticStyle: { "margin-bottom": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.enterGetSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "info" },
                        on: { click: _vm.resetData },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.newCode },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.add")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    align: item.center,
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "orderNumber"
                              ? _c("div", [
                                  _vm._v(
                                    " " + _vm._s(scope.row.orderNumber) + " "
                                  ),
                                ])
                              : item.prop === "paymentVoucher"
                              ? _c("div", [
                                  scope.row[item.prop] === 1
                                    ? _c(
                                        "div",
                                        { staticStyle: { color: "#00A551" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "customerManagements.approved"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : scope.row[item.prop] === 2
                                    ? _c(
                                        "div",
                                        { staticStyle: { color: "#f00" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "orderCenterCont.ReviewFailed"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[item.prop]
                                        ? "" + scope.row[item.prop]
                                        : "--"
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.operation"),
                  align: "center",
                  fixed: "right",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-around",
                              "align-items": "center",
                            },
                          },
                          [
                            scope.row.showEdit
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t("GlobalSetObj.edit"),
                                      effect: "dark",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit textOperator",
                                      on: {
                                        click: function ($event) {
                                          return _vm.newCode(scope.row)
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "20px 0", "text-align": "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 50, 100, 200, 400],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("newDrawer", {
        ref: "newCodeDialogRef",
        attrs: {
          "position-list": _vm.positionList,
          "transfer-list": _vm.TransferList,
        },
        on: { "invoke-search": _vm.enterGetSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }